export const SALES_INVOICE_STATUS_TYPES = {
    UNSHIPPED: 1,
    UNPOSTED: 2,
    POSTED: 3,
    SHIPPED: 4,
    DELIVERED: 5,
  }